module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4007-57239b63ad313ab4a76515721183f847.jpg";